import { Component, Vue } from 'vue-property-decorator';
import InputSelect from '@/components/inputs/InputSelect/InputSelect.vue';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputRadioButton from '@/components/inputs/InputRadioButton/InputRadioButton.vue';
import { AnswerChoices } from '@/models/VariousEnum';
import { QuestQuestion } from '@/models/QuestQuestion';
import { SelectOptionDTO } from '@/models/SelectOptionDTO';
import { QuestionnaireDTO } from '@/models/QuestionnaireDTO';
import QuestIdentity from '@/views/AtHome/QuestIdentity/QuestIdentity.vue';
import QuestAddress from '@/views/AtHome/QuestAddress/QuestAddress.vue';
import QuestDoctor from '@/views/AtHome/QuestDoctor/QuestDoctor.vue';
import QuestInsurance from '@/views/AtHome/QuestInsurance/QuestInsurance.vue';
import QuestQuestions from '@/views/AtHome/QuestQuestions/QuestQuestions.vue';
import AtHomeService from '@/services/atHome.service';
import LogoutButton from '@/components/LogoutButton/LogoutButton.vue';

@Component({
  components: {
    InputSelect,
    InputText,
    InputRadioButton,
    QuestIdentity,
    QuestAddress,
    QuestDoctor,
    QuestInsurance,
    QuestQuestions,
    LogoutButton,
  },
})
export default class QuestRecap extends Vue {
  public partId: number | undefined;
  public questionnaire: QuestionnaireDTO = {} as QuestionnaireDTO;
  public questions: QuestQuestion = {} as QuestQuestion;
  public readonly: boolean = true;
  public answerChoices: any = AnswerChoices;
  public selectChoices: SelectOptionDTO[] = [];
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;

  protected mounted() {
    this.partId = Number(this.$route.params.partId);
    // this.fetchQuestionnaire(this.partId);
    this.questionnaire = this.$store.state.questionnaire;
  }

  protected onSubmit() {
    AtHomeService.saveContent(this.toDto(this.questionnaire))
      .then(() => {
        this.$router.push({
          name: 'atHomeConfirmation',
          params: {
            screening: this.$route.params.screening,
          },
        });
      });
  }

  protected onQuit() {
    this.$router.push({
      name: 'atHomeQuestions',
      params: {
        screening: this.$route.params.screening,
        partId: String(this.partId),
      },
    });
  }

  protected toDto(quest: QuestionnaireDTO): QuestionnaireDTO {
    const questClone = JSON.parse(JSON.stringify(quest));

    // A locality was chosen in the dropdown, so clear manual data of the locality
    if (!this.$store.state.localityNotInList && quest.address.locality !== null) {
      questClone.address.localityManual = null;

      if (questClone.address.locality.locId < 0) {
        questClone.address.locality = null;
      }
    }

    // "locality not in list was checked" so clear the locality object
    if (this.$store.state.localityNotInList) {
      questClone.address.locality = null;
    }

    // A doctor was chosen in the dropdown, so clear manual data of the doctor
    if (!this.$store.state.noDoctorInList && quest.doctor.doctor !== null) {
      questClone.doctor.doctorFirstname = null;
      questClone.doctor.doctorLastname = null;
      questClone.doctor.doctorAddress = null;
      questClone.doctor.doctorLocality = null;
      questClone.doctor.doctorPhone = null;

      // In case "No doctor" was chosen, clear the doctor object
      if (quest.doctor.doctor.doctorId < 0) {
        questClone.doctor.doctor = null;
      }
    }
    if (!this.$store.state.noDoctorOtherInList && quest.doctor.doctorOther !== null && quest.doctor.doctorOther !== undefined) {
      questClone.doctor.doctorOtherFirstname = null;
      questClone.doctor.doctorOtherLastname = null;
      questClone.doctor.doctorOtherAddress = null;
      questClone.doctor.doctorOtherLocality = null;
      questClone.doctor.doctorOtherPhone = null;

      // In case "No doctor" was chosen, clear the doctor object
      if (quest.doctor.doctorOther.doctorId < 0) {
        questClone.doctor.doctorOther = null;
      }
    }

    // "Doctor not in list was checked" so clear the doctor object
    if (this.$store.state.noDoctorInList) {
      questClone.doctor.doctor = null;
    }

    if (this.$store.state.noDoctorOtherInList) {
      questClone.doctor.doctorOther = null;
    }

    const questionnaireToSave = questClone as QuestionnaireDTO;
    questionnaireToSave.lngName = this.$i18n.locale;

    return questionnaireToSave;
  }
}
